import { render, staticRenderFns } from "./ConfigurationIcon.vue?vue&type=template&id=2c19fa26&"
import script from "./ConfigurationIcon.vue?vue&type=script&lang=js&"
export * from "./ConfigurationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports